import { Add, SettingsRemote } from "@mui/icons-material";
import { Box, Card } from "@mui/material";
import { DEVICE_DOWNLOAD_COLS } from "components/modules/Device/helper.js";
import { USER_PERMISSIONS } from "components/modules/Management/AccessManagement/helper.js";
import { handleDownloadCsv, handlePrintCsv } from "components/utils/handlers.js";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { accessActions } from "../../../redux/slice/access.slice.js";
import { devicesActions } from "../../../redux/slice/devices.slice.js";
import { DELETE_DEVICES } from "../../../redux/types/devices.types";
import { openRemoteConsole } from "../../modules/SingleDashboard/helper.js";
import { DeviceStatus } from "../../utils/enums.js";
import { filterItemsById } from "../../utils/index.js";
import { checkSinglePermission } from "../helper.js";
import CustomTable from "./CustomTable";
import MyTableToolbar from "./MyTable/MyTableToolbar";
import tables from "./table.module.scss";
import { authActions } from "../../../redux/slice/auth.slice.js";

const CustomTableContainer = ({
  devices,
  toggleDrawer,
  isDrawerOpen,
  selectedRow,
  setSelectedRow,
  handleBtn1Click,
  deviceCols,
  onSearch,
  handleRowUpdate
}) => {
  const dispatch = useDispatch();
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)
  const currentUser = useSelector(authActions.selectors.getCurrentUser);

  const [selectedRows, setSelectedRows] = useState([]);
  const handleDeleteClick = () => {
    if (!selectedRows?.length) {
      toast.error("Please Select Device");
      return
    }
    const payload = {
      deviceIds: selectedRows,
    };
    dispatch({ type: DELETE_DEVICES, payload });
  };
  const handleSelectedRows = (ids) => {
    setSelectedRows(ids);
  };

  const handleDownload = () => {
    handleDownloadCsv({ rows: devices, columns: DEVICE_DOWNLOAD_COLS, name: "devices", isDevice: true })
  }

  const handlePrint = () => {
    handlePrintCsv({ rows: devices, columns: DEVICE_DOWNLOAD_COLS, name: "devices", isDevice: true })
  }

  const handleRemoteConsole = () => {
    const filteredDevices = filterItemsById(devices, selectedRows);
    const isAnyDisconnected = filteredDevices?.some(dev => dev.status !== DeviceStatus.connected);
    if (isAnyDisconnected) {
      toast.error("Cannot open remote console: One or more selected devices are disconnected.");
      return
    }
    const isOperatingSystemSame = filteredDevices?.every(dev => dev?.systemDetails?.os === filteredDevices[0]?.systemDetails?.os);
    if (!isOperatingSystemSame) {
      toast.error("Cannot open remote console: Selected devices have different operating systems.");
      return;
    } dispatch(devicesActions.actions.setSelectedDevicesAll(filteredDevices))
    openRemoteConsole('multi')
  }

  return (
    <Card className={tables.tableContainer}>
      <MyTableToolbar
        handleDeleteClick={handleDeleteClick}
        handleBtn1Click={handleBtn1Click}
        handleBtn2Click={handleRemoteConsole}
        placeHolder={"Search for Devices"}
        btn1Txt={checkSinglePermission(USER_PERMISSIONS.ENROLL_DEVICE, userPermissions, currentUser?.role) ? "Add Single Device" : null}
        btn1Icon={Add}
        btn2Txt={selectedRows?.length && checkSinglePermission(USER_PERMISSIONS.ACCESS_MULTI_DEVICE_CONSOLE, userPermissions, currentUser?.role) ? "Remote Console" : ''}
        btn2Icon={SettingsRemote}
        onSearch={onSearch}
        onDownload={handleDownload}
        onPrint={handlePrint}
        isUninstall={checkSinglePermission(USER_PERMISSIONS.DELETE_DEVICE, userPermissions, currentUser?.role)}
        walkThroughClassName="register_device"
      />
      <Box >
        <CustomTable
          handleSelectedRows={handleSelectedRows}
          deviceCols={deviceCols}
          handleRowUpdate={handleRowUpdate}
          devices={devices}
          isDrawerOpen={isDrawerOpen}
          toggleDrawer={toggleDrawer}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      </Box>
    </Card>
  );
};

export default CustomTableContainer;
